import { defineAsyncComponent } from 'vue';

export const settingsMicroFrontends = {
	PdfTemplateCustomCss: defineAsyncComponent(
		() =>
			import('./components/PdfTemplateCustomCss/PdfTemplateCustomCss.vue')
	),
	SettingsDropdownButton: defineAsyncComponent(
		() => import('./components/SettingsDropdown/SettingsDropdownButton.vue')
	),
	SingleSignOnRegularLoginUsers: defineAsyncComponent(
		() =>
			import(
				'./components/SingleSignOnRegularLoginUsers/SingleSignOnRegularLoginUsers.vue'
			)
	),
	TagColorPicker: defineAsyncComponent(
		() => import('./components/TagColorPicker/TagColorPicker.vue')
	),
};
